import { defineMessages } from 'react-intl';

const messages = defineMessages({
  delimiterHelperText: {
    id: 'DelimitedInput.DelimiterHelperText',
    defaultMessage: 'The dividing character used between values',
  },
  delimiterLabel: {
    id: 'DelimitedInput.DelimiterLabel',
    defaultMessage: 'Delimiter',
  },
  spaceOption: {
    id: 'DelimitedInput.SpaceOption',
    defaultMessage: 'Space',
  },
  commaOption: {
    id: 'DelimitedInput.CommaOption',
    defaultMessage: 'Comma',
  },
  semiColonOption: {
    id: 'DelimitedInput.SemiColonOption',
    defaultMessage: 'Semicolon',
  },
  newLineOption: {
    id: 'DelimitedInput.NewLineOption',
    defaultMessage: 'New Line',
  },
  customDelimiterLabel: {
    id: 'DelimitedInput.CustomDelimiterLabel',
    defaultMessage: 'Custom Delimiter',
  },
  customDelimiterHelper: {
    id: 'DelimitedInput.CustomDelimiterHelper',
    defaultMessage:
      'Custom dividing character(s) between values (must be exact)',
  },
  otherOption: {
    id: 'DelimitedInput.OtherOption',
    defaultMessage: 'Other',
  },
  rawTextLabel: {
    id: 'DelimitedInput.RawTextLabel',
    defaultMessage: 'Data',
  },
  rawTextHelper: {
    id: 'DelimitedInput.RawTextHelper',
    defaultMessage:
      'The values you want to search for, seperated by the defined delimiter',
  },
});

export default messages;
